import { render, staticRenderFns } from "./receipt-template-form.vue?vue&type=template&id=ed2c499a&scoped=true"
import script from "./receipt-template-form.vue?vue&type=script&lang=ts"
export * from "./receipt-template-form.vue?vue&type=script&lang=ts"
import style0 from "./receipt-template-form.vue?vue&type=style&index=0&id=ed2c499a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed2c499a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ed2c499a')) {
      api.createRecord('ed2c499a', component.options)
    } else {
      api.reload('ed2c499a', component.options)
    }
    module.hot.accept("./receipt-template-form.vue?vue&type=template&id=ed2c499a&scoped=true", function () {
      api.rerender('ed2c499a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/shared/components/receipt/receipt-template-form.vue"
export default component.exports